import { render } from "./TicketIconPreview.vue?vue&type=template&id=fdb12ad4"
import script from "./TicketIconPreview.vue?vue&type=script&lang=js"
export * from "./TicketIconPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__